import { getMainCategorySlugs } from 'util/project/helpers';

export const mainCategorySlugs = Object.freeze(getMainCategorySlugs());
